var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"userTrendUserIcon"},[_c('Tooltip',{attrs:{"text":_vm.$t('cvUserHelp')}},[_c('div',{staticClass:"userTrendUserIcon__iconContainer",attrs:{"data-cy":"user-trend-user-icon-cell-icon-container"},on:{"click":_vm.onClick}},[_c('UserIconDefault',{staticClass:"userTrendUserIcon__icon"})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }